import axios from 'axios';
import { END_POINT } from '../const/enviroment';

const HTTP = axios.create({
  baseURL: END_POINT,
  timeout: 5000,
});

export default HTTP;